module.exports = __webpack_public_path__ + "home.jpg?468a60b0d50b17bdb91be6345e81c014";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home.jpg
// module id = 96
// module chunks = 0